package com.iregained.site.components.sections.resources.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val ResourcesCtaContainerStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .backgroundColor(colorMode.toSitePalette().brand.primary) // High-contrast Brand Teal
        .color(Colors.White)
        .display(DisplayStyle.Flex)
        .justifyContent(com.varabyte.kobweb.compose.css.JustifyContent.Center)
        .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
}

val ResourcesCtaContentStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .maxWidth(800.px)
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
        .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
}

val ResourcesCtaHeadlineStyle = CssStyle.base {
    Modifier
        .fontSize(2.5.cssRem)
        .fontWeight(FontWeight.Bold)
        .textAlign(com.varabyte.kobweb.compose.css.TextAlign.Center)
        .lineHeight(1.2)
        .margin(bottom = 16.px)
}

val ResourcesCtaSubheadlineStyle = CssStyle.base {
    Modifier
        .fontSize(1.125.cssRem)
        .fontWeight(FontWeight.Normal)
        .textAlign(com.varabyte.kobweb.compose.css.TextAlign.Center)
        .lineHeight(1.6)
        .margin(bottom = 40.px)
        .opacity(90.percent) // Slightly softens the text against the dark background
}

val ResourcesCtaButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .color(colorMode.toSitePalette().brand.primary) // Inverted text color
            .fontSize(1.1.cssRem)
            .fontWeight(FontWeight.Bold)
            .padding(topBottom = 16.px, leftRight = 40.px)
            .borderRadius(8.px)
            .textDecorationLine(TextDecorationLine.None)
            .transition(Transition.of("transform", 200.ms), Transition.of("box-shadow", 200.ms))
    }
    hover {
        Modifier
            .transform { translateY((-4).px) }
            .boxShadow(0.px, 12.px, 24.px,color= Colors.Black.copy(alpha = 25))
    }
}